module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero--wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero--right"
  }, [_c('p', {
    staticClass: "hero--text"
  }, [_vm._v("A guide to typography that compares English and Korean typeforms.")]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  }), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/origins-of-type"
    }
  }, [_vm._v("Start Exploring →")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dark"
  }, [_c('div', {
    staticClass: "spacer--medium"
  }), _vm._v(" "), _c('app-menu'), _vm._v(" "), _c('div', {
    staticClass: "spacer--large clear"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero--left"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/index/types-of-type-index-logo.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5883354","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 156
// module chunks = 0